<template>
  <div data-test="logout__page">Déconnexion...</div>
</template>
<script>
export default {
  created() {
    this.$mixpanel.track('Déconnexion utilisateur', {
      app: 'inventaire',
      userAgent: navigator.userAgent,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
    });
    this.$store.dispatch('auth/logout').then(() => {
      setTimeout(() => {
        this.$router.push({ name: 'Login' });
      }, 2000);
    });
  },
};
</script>
<style lang="scss" scoped>
</style>
